import { ACTION_TYPES, withBoxComponentMobile as withBoxComponent } from '@vpp-frontend-components/with-box-component';

const { MODAL, LINK } = ACTION_TYPES;

export { withBoxComponent, MODAL, LINK };
